import React from 'react';
import { Box, Stack, TextField, MenuItem } from '@mui/material';
import { EventRepeatOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateComplianceSchedule } from '../../../state';
import { useGetComplianceFrequenciesQuery } from '../../../../../services/DimensionService/dimensionApi';

/**
 * ScheduleSection - Compliance schedule fields
 * Contains required frequency, next due date, and reminder lead time
 */
export const ScheduleSection: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentComplianceItem } = useAppSelector(state => state.compliance);
  const { data: frequencies = [] } = useGetComplianceFrequenciesQuery();

  const handleFrequencyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateComplianceSchedule({ frequencyRequired: event.target.value }));
  };

  const handleNextDueDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateComplianceSchedule({ nextDueDate: event.target.value ? new Date(event.target.value).toISOString() : undefined }));
  };

  const handleReminderDaysChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateComplianceSchedule({ reminderDays: Number(event.target.value) || 0 }));
  };

  return (
    <Box>
      <SectionHeader
        icon={<EventRepeatOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Schedule"
      />
      <SectionPaper>
        <Stack direction="row" gap={2}>
          <TextField
            label="Frequency Required"
            size="small"
            required
            select
            fullWidth
            value={currentComplianceItem?.frequencyRequired || ''}
            onChange={handleFrequencyChange}
          >
            <MenuItem value="">
              <em>Select Frequency</em>
            </MenuItem>
            {frequencies.map((f) => (
              <MenuItem key={f.value} value={f.value}>
                {f.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Next Due Date"
            size="small"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={currentComplianceItem?.nextDueDate?.slice(0, 10) || ''}
            onChange={handleNextDueDateChange}
          />
          <TextField
            label="Reminder Days"
            size="small"
            type="number"
            fullWidth
            value={currentComplianceItem?.reminderDays ?? 30}
            onChange={handleReminderDaysChange}
          />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default ScheduleSection;
